import { render, staticRenderFns } from "./largeCodeBox.vue?vue&type=template&id=701d5455&scoped=true"
import script from "./largeCodeBox.vue?vue&type=script&lang=js"
export * from "./largeCodeBox.vue?vue&type=script&lang=js"
import style0 from "./largeCodeBox.vue?vue&type=style&index=0&id=701d5455&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d5455",
  null
  
)

export default component.exports